// YOU PROVIDE THESE. Sections render only when filled in, so nothing fake is shown.
import Gs from "../assets/logo/gsLogo.png";

// Headline numbers, e.g. { value: "1.2M", label: "tCO2e avoided" }
export const stats = [{ value: "60", label: "team members" }];

// Partner / client / registry logos, e.g. { name: "Acme", src: importedImage, href: "https://..." }
export const logos = [{ name: "Gold Standard", src: Gs }];

// Testimonials, e.g. { quote: "...", name: "...", role: "...", org: "..." }
export const testimonials = [];

// Certificates / documents, e.g. { title: "Gold Standard certificate", href: "/docs/x.pdf" }
export const certificates = [];
